import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Container,
  Grid,
  IconButton,
  InputLabel,
  Modal,
  SelectChangeEvent,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import backArrow from "../../../../assets/icons/backArrow.svg";
import { CustomButton, CustomInput } from "../../../../global/components";
import CustomLoader from "../../../../global/components/CustomLoader/CustomLoader";
import CustomSelect from "../../../../global/components/CustomSelect/CustomSelect";
import strings from "../../../../global/constants/StringConstants";
import { handleErrorMessage, isTruthy } from "../../../../helpers/methods";
import history from "../../../../utils/history";
import { theme } from "../../../../utils/styles";
import {
  days,
  hours,
  minutesSeconds,
  years,
} from "../../../Calculator/CalculatorData";
import { formData, formValidation } from "../Football/FootballValidation";
import PdfConvertor from "../Report/PdfConvertor";
import resumeStyles from "./Resume.styles";
import { fetchResumeDetails } from "./ResumeService";

const Resume = () => {
  const classes = resumeStyles;
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [content, setContent] = useState<any>();
  const optionMenu = [
    { value: "gpt-4o-mini", content: "gpt-4o-mini" },
    { value: "claude-3-7-sonnet", content: "claude-3-7-sonnet" },
  ];

  const [model, setModel] = useState<string>("gpt-4o-mini");
  const [formFields, setFormFields] = useState(formData);
  const [address, setAddress] = useState<any>({
    latitude: "",
    longitude: "",
    location: "",
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const bloodGroupMenu = [
    { value: 0, content: `${t("optional")}`, disabled: true },
    { value: "A+", content: "A+" },
    { value: "A-", content: "A-" },
    { value: "B+", content: "B+" },
    { value: "B-", content: "B-" },
    { value: "O+", content: "O+" },
    { value: "O-", content: "O-" },
    { value: "AB+", content: "AB+" },
    { value: "AB-", content: "AB-" },
  ];

  const genderMenu = [
    { value: "Man", content: `${t("man")}` },
    { value: "Woman", content: `${t("woman")}` },
  ];

  const yearMenu = [
    { value: 0, content: `${t("year")}`, disabled: true },
    ...years,
  ];

  const monthMenu = [
    { value: 0, content: `${t("month")}`, disabled: true },
    { content: `${t("january")}`, value: 1 },
    { content: `${t("february")}`, value: 2 },
    { content: `${t("march")}`, value: 3 },
    { content: `${t("april")}`, value: 4 },
    { content: `${t("may")}`, value: 5 },
    { content: `${t("june")}`, value: 6 },
    { content: `${t("july")}`, value: 7 },
    { content: `${t("august")}`, value: 8 },
    { content: `${t("september")}`, value: 9 },
    { content: `${t("october")}`, value: 10 },
    { content: `${t("november")}`, value: 11 },
    { content: `${t("december")}`, value: 12 },
  ];

  const dateMenu = [
    { value: 0, content: `${t("date")}`, disabled: true },
    ...days,
  ];

  const hoursMenu = [
    { value: -1, content: `${t("hour")}`, disabled: true },
    ...hours,
  ];

  const minutesMenu = [
    { value: -1, content: `${t("minute")}`, disabled: true },
    ...minutesSeconds,
  ];

  const secondsMenu = [
    { value: -1, content: `${t("second")}`, disabled: true },
    ...minutesSeconds,
  ];

  useEffect(() => {
    address.location &&
      setFormFields({
        ...formFields,
        birthPlace: {
          ...formFields.birthPlace,
          value: address.location,
        },
      });
    !formFields.birthPlace.value &&
      setAddress({
        ...address,
        location: "",
      });
  }, [address.location]);

  useEffect(() => {
    initialize();
  }, []);

  const handlePlaceChanged = async (autocomplete: any) => {
    const place = autocomplete.getPlace();
    const { geometry } = place;
    if (geometry && geometry.location) {
      const latitude = geometry.location.lat();
      const longitude = geometry.location.lng();
      setAddress({
        ...address,
        latitude: latitude,
        longitude: longitude,
        location: place.formatted_address,
      });
    }
  };

  function initialize() {
    const input: any = document.getElementById("birthPlace");
    const autocomplete: any = new google.maps.places.Autocomplete(input);
    google.maps.event.addListener(autocomplete, "place_changed", () =>
      handlePlaceChanged(autocomplete),
    );
  }

  const handleFieldChange = (event: any) => {
    setFormFields({
      ...formFields,
      [event.target.name]: {
        ...formFields[event.target.name],
        value: event.target.value,
        error: "",
      },
    });
    if (event.target.name === "birthPlace") {
      setAddress({
        latitude: "",
        longitude: "",
        location: "",
      });
    }
  };

  const handleValidation = () => {
    const { isValid, errors } = formValidation(formFields, address);
    setFormFields({ ...errors });
    return isValid;
  };

  const getResumeDetails = async (e: React.FormEvent) => {
    try {
      e.preventDefault();
      if (handleValidation()) {
        const profileData = {
          // firstName: formFields.firstName.value.trim(),
          // lastName: formFields.lastName.value.trim(),
          // birthDate:
          //   `${formFields.year.value}-${formFields.month.value}-${formFields.date.value}` +
          //   " " +
          //   `${formFields.hours.value}:${formFields.minutes.value}:${formFields.seconds.value}`,
          // longitude: address.longitude,
          // latitude: address.latitude,
          // altitude: "0",
          // bloodGroup: formFields.bloodGroup.value,
          // timezone: address.timezone,
          // pregnancy: +formFields.pregnancy.value,
          // sex: formFields.sex.value,
          // birthPlace: formFields.birthPlace.value,

          first_person: {
            name:
              formFields.firstName.value.trim() +
              " " +
              formFields.lastName.value.trim(),
            birth_date:
              `${formFields.year.value}-${formFields.month.value}-${formFields.date.value}` +
              " " +
              `${formFields.hours.value}:${formFields.minutes.value}:${formFields.seconds.value}`,
            longitude: address.longitude,
            latitude: address.latitude,
            altitude: "0",
            blood_group: formFields.bloodGroup.value,
            timezone: "Asia/Kolkata",
            isVedic: "1",
          },
        };
        setIsLoading(true);
        const response = await fetchResumeDetails(profileData, model);

        setContent(
          `<p>
            <div style="text-align:left; font-weight:normal; color:black; font-size:18px; line-height:0.1;"></div>
            <div style="text-align:left; font-weight:normal; color:#666; font-size:14px; line-height:0.1; margin-bottom: 20px;">
            <div style="font-weight:bold; color:black; font-size:22px;">${formFields.firstName.value}</div>
              <div>${formFields.year.value}-${formFields.month.value}-${formFields.date.value} ${formFields.hours.value}:${formFields.minutes.value}:${formFields.seconds.value}</div>
              <div>${formFields?.birthPlace?.value}</div>
            </div>
            <p>${response.data}</p>
           </p>`,
        );
        setIsOpen(true);
        setIsLoading(false);
      }
    } catch (error: any) {
      setIsLoading(false);
      handleErrorMessage(error);
    }
  };

  const getForm = () => {
    return (
      <>
        <Grid container spacing={1} justifyContent={"start"} p={2}>
          <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
            <CustomInput
              required
              label={t("firstName")}
              name="firstName"
              value={formFields.firstName.value}
              onChange={handleFieldChange}
              placeHolder={t("firstNamePlaceholder")}
              autoComplete="off"
              error={
                !isTruthy(formFields.firstName.value) &&
                formFields.firstName.error
              }
            />
          </Grid>
          <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
            <CustomInput
              label={t("lastName")}
              name="lastName"
              value={formFields.lastName.value}
              onChange={handleFieldChange}
              placeHolder={t("lastNamePlaceholder")}
              autoComplete="off"
            />
          </Grid>
          <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
            <CustomSelect
              label={t("bloodGroup")}
              menuItems={bloodGroupMenu}
              onChange={handleFieldChange}
              id={"bloodGroup"}
              name={"bloodGroup"}
              value={formFields.bloodGroup.value}
            />
          </Grid>
          <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
            <CustomSelect
              required
              label={t("sex")}
              menuItems={genderMenu}
              onChange={handleFieldChange}
              id={"sex"}
              name={"sex"}
              value={formFields.sex.value}
            />
          </Grid>
          <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
            <Box mt={2}>
              <InputLabel required sx={classes.nameField}>
                {t("birthDate")}
              </InputLabel>
            </Box>
          </Grid>
          <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
            <CustomSelect
              menuItems={yearMenu}
              onChange={handleFieldChange}
              id={"year"}
              name={"year"}
              value={formFields.year.value}
              error={formFields.year.error}
            />
          </Grid>
          <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
            <CustomSelect
              menuItems={monthMenu}
              onChange={handleFieldChange}
              id={"month"}
              name={"month"}
              value={formFields.month.value}
              error={formFields.month.error}
            />
          </Grid>
          <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
            <CustomSelect
              menuItems={dateMenu}
              onChange={handleFieldChange}
              id={"date"}
              name={"date"}
              value={formFields.date.value}
              error={formFields.date.error}
            />
          </Grid>
          <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
            <Box mt={2}>
              <InputLabel required sx={classes.nameField}>
                {t("birthTime")}
              </InputLabel>
            </Box>
          </Grid>
          <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
            <CustomSelect
              menuItems={hoursMenu}
              onChange={handleFieldChange}
              id={"hours"}
              name={"hours"}
              value={formFields.hours.value}
              error={formFields.hours.error}
            />
          </Grid>
          <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
            <CustomSelect
              menuItems={minutesMenu}
              onChange={handleFieldChange}
              id={"minutes"}
              name={"minutes"}
              value={formFields.minutes.value}
              error={formFields.minutes.error}
            />
          </Grid>
          <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
            <CustomSelect
              menuItems={secondsMenu}
              onChange={handleFieldChange}
              id={"seconds"}
              name={"seconds"}
              value={formFields.seconds.value}
              error={formFields.seconds.error}
            />
          </Grid>
          <Grid item xl={4} lg={4} md={4} sm={12} xs={12} mt={2}>
            <CustomInput
              required
              label={t("birthPlace")}
              placeHolder={t("place")}
              id="birthPlace"
              type="birthPlace"
              name="birthPlace"
              value={formFields.birthPlace.value}
              onChange={handleFieldChange}
              error={
                !isTruthy(
                  formFields.birthPlace.value &&
                    address.latitude &&
                    address.longitude,
                ) && formFields.birthPlace.error
              }
            />
          </Grid>
        </Grid>
        <Box
          width={"100%"}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minWidth: "200px",
          }}
        >
          <Box margin={1}>
            <CustomButton
              label={t("generate")}
              type={strings.PRIMARY}
              onClick={getResumeDetails}
            />
          </Box>
        </Box>
      </>
    );
  };

  const getHeader = () => {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: { sm: "center", xs: "baseline" },
          width: "100%",
        }}
        pb={3}
      >
        <Box
          display={"flex"}
          alignItems={"center"}
          sx={{ cursor: "pointer", width: "fit-content" }}
          onClick={() => history.goBack()}
        >
          {isMobile ? (
            <img src={backArrow} height={"20px"} alt="Module not found..." />
          ) : (
            <img src={backArrow} height={"25px"} alt="Module not found..." />
          )}
        </Box>
        <Typography sx={classes.italicTypo}>{t("resume")}</Typography>
        <Box sx={{ display: "flex", gap: "20px" }}>
          <CustomSelect
            menuItems={optionMenu}
            onChange={(event: SelectChangeEvent<string>) =>
              setModel(event.target.value)
            }
            value={model}
            name={"house"}
            id={"house"}
            customClasses={classes.darkTextField}
          />
        </Box>
      </Box>
    );
  };

  return (
    <>
      <Box sx={classes.mainContainer}>
        <Box sx={classes.mainBox}>
          <Box sx={classes.subBox}>
            <Box sx={classes.scrollStyle}>
              <Container maxWidth="xl" sx={{ px: 1 }}>
                {getHeader()};{getForm()};
              </Container>
            </Box>
          </Box>
        </Box>
      </Box>
      <CustomLoader isLoading={isLoading} />
      <Modal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            height: "90%",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <IconButton
            onClick={() => setIsOpen(false)}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <CloseIcon />
          </IconButton>

          <Box
            sx={{
              mt: 4,
              flex: 1,
              overflowY: "auto",
              pr: 1,
            }}
          >
            <PdfConvertor
              content={content}
              fileName={formFields.firstName.value!}
            />
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default Resume;
